import React, { useEffect, useState } from "react";
import api, { showAlert } from "../../util/api";

const emptyForm = {
    position: "",
    organization: "",
    description: "",
    start_year: "",
    end_year: "",
    current: false,
};

const Career = () => {
    const [items, setItems] = useState([]);

    const [form, setForm] = useState(emptyForm);

    const [editingId, setEditingId] = useState(null);

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const [message, setMessage] = useState("");

    useEffect(() => {
        fetchCareer();
    }, [items]);

    const fetchCareer = async () => {
        try {
            const response = await api.get("/admin/career");

            const result = await response.data;

            if (result.success) {
               
                setItems(result.data || []);
            }
        } catch (error) {
            console.error(
                "Error fetching career:",
                error
            );
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]:
                type === "checkbox"
                    ? checked
                    : value,
        }));
    };

    const resetForm = () => {
        setForm(emptyForm);
        setEditingId(null);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setSaving(true);
        setMessage("");

        const isEditing = Boolean(editingId);

        const url = isEditing
            ? `/admin/career/${editingId}`
            : "/admin/career";

        try {

              let response ;
           

            if(isEditing ){
                 response = await api.put(url, {
                    ...form,
                    start_year: form.start_year || null,
                    end_year: form.end_year || null,
                });

            }else{

                 response = await api.post("/admin/career", {
                    ...form,
                    start_year: form.start_year || null,
                    end_year: form.end_year || null,
                });
            }

          
      

            const result = await response.data;

            if (result.success  === false) {
                throw new Error(
                    result.message ||
                    "Unable to save career record."
                );
            }

            setMessage(
                isEditing
                    ? "Career record updated successfully."
                    : "Career record created successfully."
            );

             showAlert('success', 'success!',  isEditing
                    ? "Career record updated successfully."
                    : "Career record created successfully." );

            resetForm();

             fetchCareer();

        } catch (error) {
            setMessage(error.message);
        } finally {
            setSaving(false);
        }
    };

    const editItem = (item) => {
        setEditingId(item.id);

        setForm({
            position: item.position || "",
            organization:
                item.organization || "",
            description:
                item.description || "",
            start_year:
                item.start_year || "",
            end_year:
                item.end_year || "",
            current:
                Boolean(item.current),
        });

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    const deleteItem = async (id) => {
        const confirmed = window.confirm(
            "Are you sure you want to delete this career record?"
        );

        if (!confirmed) {
            return;
        }

        try {
            const response = await api.delete(`/admin/career/${id}`);

            const result = await response.data;

            if (result.success  ===  false) {
                throw new Error(
                    result.message ||
                    "Unable to delete record."
                );
            }

          
            showAlert('success', 'success!', "Career record deleted successfully." );

            setMessage(
                "Career record deleted successfully."
            );

             fetchCareer();

        } catch (error) {
            alert("erro");
            setMessage(error.message);
        }
    };

    if (loading) {
        return (
            <div className="admin-page-loading">
                Loading career timeline...
            </div>
        );
    }

    return (
        <div className="admin-career-page">

            <div className="admin-page-header">

                <div>

                    <span className="admin-page-eyebrow">
                        WEBSITE CONTENT
                    </span>

                    <h1>
                        Career & Timeline
                    </h1>

                    <p>
                        Manage career history,
                        appointments and public
                        service timeline.
                    </p>

                </div>

            </div>

            {message && (
                <div className="admin-form-message">
                    {message}
                </div>
            )}

            {/* FORM */}

            <div className="admin-panel">

                <div className="admin-panel-header">

                    <div>

                        <span>
                            {editingId
                                ? "EDIT RECORD"
                                : "NEW RECORD"}
                        </span>

                        <h2>
                            Career Information
                        </h2>

                    </div>

                </div>

                <form
                    className="admin-form"
                    onSubmit={handleSubmit}
                >

                    <div className="admin-form-row">

                        <div className="admin-form-group">

                            <label>
                                Position
                            </label>

                            <input
                                type="text"
                                name="position"
                                value={form.position}
                                onChange={handleChange}
                                placeholder="Member"
                                required
                            />

                        </div>

                        <div className="admin-form-group">

                            <label>
                                Organization
                            </label>

                            <input
                                type="text"
                                name="organization"
                                value={
                                    form.organization
                                }
                                onChange={handleChange}
                                placeholder="Ekiti State House of Assembly"
                                required
                            />

                        </div>

                    </div>

                    <div className="admin-form-group">

                        <label>
                            Description
                        </label>

                        <textarea
                            name="description"
                            value={
                                form.description
                            }
                            onChange={handleChange}
                            rows="4"
                            placeholder="Describe the role..."
                        />

                    </div>

                    <div className="admin-form-row">

                        <div className="admin-form-group">

                            <label>
                                Start Year
                            </label>

                            <input
                                type="number"
                                name="start_year"
                                value={
                                    form.start_year
                                }
                                onChange={handleChange}
                                placeholder="2023"
                                min="1900"
                                max="2200"
                            />

                        </div>

                        <div className="admin-form-group">

                            <label>
                                End Year
                            </label>

                            <input
                                type="number"
                                name="end_year"
                                value={
                                    form.end_year
                                }
                                onChange={handleChange}
                                placeholder="2027"
                                min="1900"
                                max="2200"
                                disabled={form.current}
                            />

                        </div>

                    </div>

                    <label className="admin-toggle">

                        <input
                            type="checkbox"
                            name="current"
                            checked={form.current}
                            onChange={handleChange}
                        />

                        <span className="admin-toggle-slider"></span>

                        <span>

                            <strong>
                                Current Position
                            </strong>

                            <small>
                                Mark this as the person's
                                current role.
                            </small>

                        </span>

                    </label>

                    <div className="admin-career-form-actions">

                        <button
                            type="submit"
                            className="admin-primary-button"
                            disabled={saving}
                        >
                            {saving
                                ? "Saving..."
                                : editingId
                                    ? "Update Record"
                                    : "Add Career Record"}
                        </button>

                        {editingId && (
                            <button
                                type="button"
                                className="admin-secondary-button"
                                onClick={resetForm}
                            >
                                Cancel
                            </button>
                        )}

                    </div>

                </form>

            </div>

            {/* TIMELINE */}

            <div className="admin-panel admin-career-list">

                <div className="admin-panel-header">

                    <div>

                        <span>
                            CAREER HISTORY
                        </span>

                        <h2>
                            Public Service Timeline
                        </h2>

                    </div>

                    <span className="admin-record-count">
                        {items.length}{" "}
                        {items.length === 1
                            ? "Record"
                            : "Records"}
                    </span>

                </div>

                {items.length === 0 ? (

                    <div className="admin-empty-state">
                        No career records have been
                        added yet.
                    </div>

                ) : (

                    <div className="admin-career-timeline">

                        {items.map((item, index) => (

                            <div
                                className="admin-career-item"
                                key={item.id}
                            >

                                <div className="admin-career-marker">
                                    <span>
                                        {String(
                                            index + 1
                                        ).padStart(2, "0")}
                                    </span>
                                </div>

                                <div className="admin-career-content">

                                    <div className="admin-career-meta">

                                        <span>
                                            {item.start_year ||
                                                "—"}
                                            {" — "}
                                            {item.current
                                                ? "PRESENT"
                                                : item.end_year ||
                                                  "—"}
                                        </span>

                                        {item.current && (
                                            <b>
                                                CURRENT
                                            </b>
                                        )}

                                    </div>

                                    <h3>
                                        {item.position}
                                    </h3>

                                    <h4>
                                        {item.organization}
                                    </h4>

                                    {item.description && (
                                        <p>
                                            {
                                                item.description
                                            }
                                        </p>
                                    )}

                                    <div className="admin-career-actions">

                                        <button
                                            type="button"
                                            onClick={() =>
                                                editItem(
                                                    item
                                                )
                                            }
                                        >
                                            Edit
                                        </button>

                                        <button
                                            type="button"
                                            onClick={() =>
                                                deleteItem(
                                                    item.id
                                                )
                                            }
                                        >
                                            Delete
                                        </button>

                                    </div>

                                </div>

                            </div>

                        ))}

                    </div>

                )}

            </div>

        </div>
    );
};

export default Career;